import { NewTemplateModal } from 'modules/templateIndex/modals/NewTemplateModal';
import { RumComponentContextProvider } from 'services/observability/datadog';
import { Product, Team } from 'teams';

type CreateTemplateModalProps = {
  id?: string;
  onClose: () => void;
};

export const CreateTemplateModal = ({ id = '', onClose }: CreateTemplateModalProps) => {
  return (
    <RumComponentContextProvider
      componentName="QuickActions/CreateTemplateModal"
      productName={Product.TEMPLATE_INDEX}
      teamName={Team.CAMPAIGN_TEAM}
    >
      <NewTemplateModal id={id} closeModal={onClose} currentFolderId={null} />
    </RumComponentContextProvider>
  );
};
